import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Route, withRouter, Switch } from 'react-router-dom'
import IndexPage from '../../pages/Index'
import RegisterPage from '../../pages/Register'
import PrivateRoute from '../PrivateRoute'
import BankTransferPage from '../../pages/BankTransfer'
import WalletHomePage from '../../pages/WalletHome'
import InvoicePage from '../../pages/Invoice'
import AddCreditCardPage from '../../pages/AddCreditCard'
import WalletRecordPage from '../../pages/WalletRecord'
import InvoiceListPage from '../../pages/InvoiceList'
import AddValuePage from '../../pages/AddValue'
import LoginPage from '../../pages/Login'
import DrawerPage from '../../pages/Drawer'

const mapStateToProps = () => {
  return {}
}

const mapDispatchToProps = () => {
  return {}
}

@withRouter
@connect(
  mapStateToProps,
  mapDispatchToProps,
)
class MainRouter extends Component {
  get routes() {
    const { match } = this.props
    return [
      {
        exact: true,
        component: IndexPage,
        wrapper: Route,
        path: match.path,
      },
      {
        component: RegisterPage,
        wrapper: Route,
        path: `${match.path}/register`,
      },
      {
        exact: true,
        component: WalletHomePage,
        wrapper: PrivateRoute,
        path: `${match.path}/user/wallet`,
      },
      {
        exact: true,
        component: BankTransferPage,
        wrapper: PrivateRoute,
        path: `${match.path}/user/wallet/redeem/bank_transfer`,
      },
      {
        exact: true,
        component: AddCreditCardPage,
        wrapper: PrivateRoute,
        path: `${match.path}/user/wallet/credit_cards/add`,
      },
      {
        exact: true,
        component: WalletRecordPage,
        wrapper: PrivateRoute,
        path: `${match.path}/user/wallet/records`,
      },
      {
        exact: false,
        component: AddValuePage,
        wrapper: PrivateRoute,
        path: `${match.path}/user/wallet/addValue`,
      },
      {
        exact: true,
        component: InvoiceListPage,
        wrapper: PrivateRoute,
        path: `${match.path}/user/invoices/:type?`,
      },
      {
        exact: true,
        component: InvoicePage,
        wrapper: PrivateRoute,
        path: `${match.path}/invoice/:id`,
      },
      {
        exact: true,
        component: LoginPage,
        wrapper: Route,
        path: `${match.path}/login`,
      },
      {
        exact: true,
        component: DrawerPage,
        wrapper: Route,
        path: `${match.path}/drawer`,
      },
    ]
  }

  render() {
    return (
      <Switch>
        {this.routes.map((route) => {
          return (
            <route.wrapper
              key={route.path}
              component={route.component}
              path={route.path}
              exact={route.exact}
            />
          )
        })}
      </Switch>
    )
  }
}

MainRouter.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.object.isRequired,
  }),
}

export default MainRouter
